import { ThemePalette } from '@/core/theme';

export const palette: ThemePalette = {
  P1: {
    $100: '#F4F6FB',
    $200: '#E7EDF7',
    $300: '#CAD9ED',
    $400: '#9CB9DD',
    $500: '#6794C9',
    $600: '#4376B4',
    $700: '#305992',
    $800: '#274673',
    $900: '#233E62',
    $1000: '#1E304B'
  },
  P2: {
    $100: '#FDFAED',
    $200: '#FAF3DB',
    $300: '#F3E3B4',
    $400: '#E7C76E',
    $500: '#E3B354',
    $600: '#DC9B32',
    $700: '#CC8528',
    $800: '#A96823',
    $900: '#8A5324',
    $1000: '#654520'
  },
  Black: {
    $300: '#F0F0F0',
    $400: '#E5E5E5',
    $500: '#D8D8D8',
    $600: '#CCCCCC',
    $700: '#999999',
    $800: '#666666',
    $900: '#333333',
    $1000: '#000000'
  },
  White: {
    $700: '#FFFFFF',
    $800: '#E8EBEE',
    $900: '#DEE3E7',
    $1000: '#CDD4DB'
  },
  Green: {
    $100: '#F0FDF5',
    $200: '#DCFCEA',
    $300: '#BCF6D5',
    $400: '#87EEB6',
    $500: '#4CDC8E',
    $600: '#23BD6A',
    $700: '#18A157',
    $800: '#167F47',
    $900: '#17643B',
    $1000: '#155233'
  },
  Orange: {
    $100: '#FBE9E7',
    $200: '#FFCCBC',
    $300: '#FFAB91',
    $400: '#FF8A65',
    $500: '#FF7043',
    $600: '#FF5722',
    $700: '#F4511E',
    $800: '#E64A19',
    $900: '#D84315',
    $1000: '#BF360C'
  },
  Red: {
    $100: '#FEF2F2',
    $200: '#FFE2E1',
    $300: '#FFC9C8',
    $400: '#FFA4A2',
    $500: '#FD6F6C',
    $600: '#F5423E',
    $700: '#E53935',
    $800: '#BE1B17',
    $900: '#9D1A17',
    $1000: '#821C1A'
  },
  Dark: {
    $100: '#F8F8F8',
    $200: '#EFEFEF',
    $300: '#DCDCDC',
    $400: '#CCCCCC',
    $500: '#AFAFAF',
    $600: '#808080',
    $700: '#666666',
    $800: '#4D4D4D',
    $900: '#333333',
    $1000: '#1A1A1A'
  },
  Background: {
    LIGHT_BLUE_BG: '#E0FFFD',
    BLUE_BG: '#E6F7FF',
    GRAY: '#666666',
    YELLOW_BG: '#FFF7D4',
    LIGHT_BLUE: '#08979C',
    BLUE: '#096DD9'
  }
};
